var clockTimer = false;
var clockServerUpdate = true;
var clockTemp = true;
var currentTime = "";

function toastrsuccess(msg) {
    UIAlerts.toast({
        title: msg,
        icon: 'success',
        background: 'rgba(25,135,84,1)', // custom solid
        color: '#fff',
        position: 'top-end'
    });
}

function toastrerror(msg) {
    UIAlerts.toast({
        title: msg,
        icon: 'error',
        background: 'rgba(220,53,69,1)', // custom solid
        color: '#fff',
        position: 'top-end'
    });
}

$(document).on("click", ".selectGridFinish", function (e) {
    e.preventDefault();
    var imgPath = $(this).data("img");
    var finishHref = $(this).data("href");
    var finishPrice = $(this).data("price");
    var finishPriceHtml = $(this).attr("data-price-html");
    var finishSku = $(this).data("sku");
    if (imgPath != undefined && imgPath != "" && imgPath != null) {
        $(this).closest(".productCard").find(".selectGridFinish.active").removeClass("active");
        $(this).addClass("active");
        $(this).closest(".productCard").find(".productGridImg").attr("src", imgPath);
    }
    if (finishHref != undefined && finishHref != "" && finishHref != null) {
        $(this).closest(".productCard").find("a").attr("href", finishHref);
    }
    if (finishPriceHtml != undefined && finishPriceHtml != "" && finishPriceHtml != null) {
        var decodedPriceHtml = atob(finishPriceHtml);
        $(this).closest(".productCard").find(".productPrice").replaceWith(decodedPriceHtml);
    } else if (finishPrice != undefined && finishPrice != "" && finishPrice != null) {
        $(this).closest(".productCard").find(".productPrice").html(`<span class="priceFrom">From -</span>
                AU$ ${finishPrice}`);
    }
    if (finishSku != undefined && finishSku != "" && finishSku != null) {
        $(this).closest(".productCard").find(".productModel").text(finishSku);
    }
});

$(document).on("click", "#authModal .closeSignInBtn", function () {
    $("#authModal .modalTitle").text("");
    $("#authModal .modalBody").html("");
    $("#authModal").hide();
});

$(document).on("click", "#commonModel .closeSignInBtn", function () {
    $("#commonModel .modalTitle").text("");
    $("#commonModel .modalBody").html("");
    $("#commonModel").hide();
});

$(document).on("click", "#commonLgModel .closeSignInBtn", function () {
    $("#commonLgModel .modalTitle").text("");
    $("#commonLgModel .modalBody").html("");
    $("#commonLgModel").hide();
});

function closeCommonModel() {
    $("#commonModel .modalTitle").text("");
    $("#commonModel .modalBody").html("");
    $("#commonModel").hide();
}

function closeCommonLgModel() {
    $("#commonLgModel .modalTitle").text("");
    $("#commonLgModel .modalBody").html("");
    $("#commonLgModel").hide();
}

function getUserDetails(FormData) {
    let formArr = {};
    FormData.forEach(function (value, key) {
        if (key == "email" || key == "phone") {
            formArr[key] = value;
        }
    });
    return formArr;
}

$(document).on("click", ".verifyEmailNow", async function (e) {
    e.preventDefault();
    var formID = $(this).closest("form").attr("id");
    var data = await ajaxDynamicMethod($(this).attr('href'), "POST", generateFormData("#" + formID), $("#" + formID));
    if (data.success) {
        $("#emailVerificationBox").show();
    }
});

$(document).on("click", "#emailVerifyNowBtn", async function (e) {
    e.preventDefault();
    var formID = $(this).closest("form").attr("id");
    var data = await ajaxDynamicMethod($(this).data('href'), "POST", generateFormData("#" + formID), $("#" + formID));
    if (data.success) {
        $("#emailVerificationBox").hide();
        $("#emailInputControl").closest(".inputWithBadge").addClass("verified");
        $("#emailInputControl").closest(".inputWithBadge").find(".verifyNow").remove();
        $("#emailInputControl").closest(".inputWithBadge").append(
            `<span class="verified-badge">Verified</span>`);
    }
});

$(document).on("click", ".verifyPhoneNow", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod($(this).attr('href'), "POST", generateFormData("#accountProfileForm"), $("#accountProfileForm"));
    if (data.success) {
        $("#phoneVerificationBox").show();
    }
});

$(document).on("click", "#phoneVerifyNowBtn", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod($(this).data('href'), "POST", generateFormData("#accountProfileForm"), $("#accountProfileForm"));
    if (data.success) {
        $("#phoneVerificationBox").hide();
        $("#phoneInputControl").closest(".inputWithBadge").addClass("verified");
        $("#phoneInputControl").closest(".inputWithBadge").find(".verifyNow").remove();
        $("#phoneInputControl").closest(".inputWithBadge").append(
            `<span class="verified-badge">Verified</span>`);
    }
});

$(document).on("submit", "#findUser", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod($(this).attr('action'), $(this).attr('method'), generateFormData(
        this));
    if (data.data.user && data.success) {
        $.ajax({
            url: dynamicRoutes.checkPassword,
            type: "POST",
            data: {
                _token: $('meta[name="csrf-token"]').attr("content"),
                formData: getUserDetails(generateFormData(this)),
            },
            success: function (res) {
                $("#authModal .modalBody").html(res);
                applyTheme();
            },
        });
    }
    else {
        if (data.success) {
            $.ajax({
                url: dynamicRoutes.verifyOtp,
                type: "POST",
                data: {
                    _token: $('meta[name="csrf-token"]').attr("content"),
                    formData: getUserDetails(generateFormData(this)),
                },
                success: function (res) {
                    $("#authModal .modalBody").html(res);
                    applyTheme();
                },
            });
        }
    }
});

$(document).on("submit", "#otp-verification", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    if (data.error) {
        $(".check-otp").val("");
    }
    if (data.success) {
        $.ajax({
            url: dynamicRoutes.register,
            type: "POST",
            data: {
                _token: $('meta[name="csrf-token"]').attr("content"),
                formData: getUserDetails(generateFormData(this)),
            },
            success: function (res) {
                $(".authModal .modalBody").html(res);
                $("#email").val("");
                $("#password").val("");
                applyTheme();
            },
        });
    }
});

$(document).on("click", "#forgot-password", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod($(this).attr("href"), "POST", generateFormData("#login-attempt"));
    if (data.success) {
        toastrsuccess("Password reset link has been sent to your email.");
    }
});

$(document).on("click", "#resend_otp", async function (e) {
    e.preventDefault();
    const route = $(this).attr("href");
    const method = $("#otp-verification").attr("method") || "POST";
    const formData = generateFormData("#otp-verification");

    var data = await ajaxDynamicMethod(route, method, formData);
    if (data.success) {
        toastrsuccess('Otp Send Successfuly');
    }
});

function startResendOTPTimer(timerInSeconds) {
    var resendBtn = $('#resend-otp');
    var countdown = timerInSeconds;

    resendBtn.addClass('disabled').css('pointer-events', 'none').text(`Resend OTP in ${countdown}s`);

    var timer = setInterval(function () {
        countdown--;
        if (countdown > 0) {
            resendBtn.text(`Resend OTP in ${countdown}s`);
        } else {
            clearInterval(timer);
            resendBtn.removeClass('disabled').css('pointer-events', 'auto').text('Resend OTP');
        }
    }, 1000);
}

$(document).on("click", "#sendlogin-otp", async function (e) {
    e.preventDefault();
    var sendloginOtpUrl = $(this).attr('href');
    var number = $(this).data('number');
    console.log(number);

    var formData = new FormData();
    formData.append("phone", number);

    const otpResponse = await ajaxDynamicMethod("/api/send-login-otp", "POST", formData, "", "No");
    if (otpResponse.success === true) {
        const formHtmlResponse = await ajaxDynamicMethod(sendloginOtpUrl, "GET");
        $(".authModal .modalBody").html(formHtmlResponse);
        applyTheme();
        const timer = formHtmlResponse.data?.resend_timer || 30;
        startResendOTPTimer(timer);
    } else {
        console.error("OTP API failed:", otpResponse);
    }
});

$(document).on("submit", "#sendLoginOtpform", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    if (data.error) {
        $(".check-otp").val("");
    }
    if (data.success) {
        location.reload();
    }
    if (data.error) {
        $(".check-password").val("");
    }
});

$(document).on("submit", "#register-form", async function (e) {
    e.preventDefault();

    if ($(this).find("#emailInputControl").length > 0 && $(this).find("#emailInputControl.verified").length == 0) {
        toastrerror("Email ID must be verified");
        return;
    }


    var registerFormData = generateFormData(this);
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        registerFormData
    );

    if (data.success) {
        var data = await ajaxDynamicMethod(
            dynamicRoutes.login,
            "POST",
            registerFormData
        );
        if (data.success) {
            location.reload();
        }
    }
});

$(document).on("submit", "#login-attempt", async function (e) {
    e.preventDefault();
    var loginFormData = generateFormData(this);
    loginFormData.append("route", window.location.pathname.replace(/^\/+/, ''));
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        loginFormData
    );
    if (data.success) {
        location.reload();
    }
    if (data.error) {
        $(".check-password").val("");
    }
});

$(document).on("click", ".modal-link", function (e) {
    e.preventDefault();
    var URL = $(this).attr("href") || $(this).data("href");
    var title = $(this).data("title");
    $("#authModal .modalTitle").text(title);
    $.ajax({
        url: URL,
        cache: false,
        beforeSend: function () {
            $("#lds-roller").show();
        },
        success: function (res) {
            $("#authModal").show();
            $("#authModal .modalBody").html(res);
            applyTheme();
            $("#lds-roller").hide();
        },
        error: function (request, status, error) {
            if (request.status == "500") {
                toastrerror(error);
                $("#lds-roller").hide();
            }
        },
    });
});
$(document).on("click", ".common-modal-link", function (e) {
    e.preventDefault();
    var URL = $(this).attr("href") || $(this).data("href");
    var title = $(this).data("title");
    $("#commonModel .modalTitle").text(title);
    $.ajax({
        url: URL,
        cache: false,
        beforeSend: function () {
            $("#lds-roller").show();
        },
        success: function (res) {
            $("#commonModel").show();
            $("#commonModel .modalBody").html(res);
            applyTheme();
            $("#lds-roller").hide();
        },
        error: function (request, status, error) {
            if (request.status == "500") {
                toastrerror(error);
                $("#lds-roller").hide();
            }
        },
    });
});
$(document).on("click", ".common-lg-modal-link", function (e) {
    e.preventDefault();
    var URL = $(this).attr("href") || $(this).data("href");
    var title = $(this).data("title");
    $("#commonLgModel .modalTitle").text(title);
    $.ajax({
        url: URL,
        cache: false,
        beforeSend: function () {
            $("#lds-roller").show();
        },
        success: function (res) {
            $("#commonLgModel").show();
            $("#commonLgModel .modalBody").html(res);
            applyTheme();
            $("#lds-roller").hide();
        },
        error: function (request, status, error) {
            if (request.status == "500") {
                toastrerror(error);
                $("#lds-roller").hide();
            }
        },
    });
});

$(document).on("click", ".cancelAddress", function (e) {
    let target = $(this).data("target");
    Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this data!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, proceed!",
    }).then((result) => {
        if (result.isConfirmed) {
            $(target).hide();
            $(target).html("");
            $("#commonModel .modalTitle").text("");
            $("#commonModel .modalBody").html("");
            $("#commonModel").hide();
        }
    });
});

$(document).on("click", ".sectionForm", function (e) {
    e.preventDefault();
    var URL = $(this).attr("href") || $(this).data("href");
    let target = $(this).data("target");
    $.ajax({
        url: URL,
        cache: false,
        beforeSend: function () {
            $("#lds-roller").show();
        },
        success: function (res) {
            $(target).show();
            $(target).html(res);
            applyTheme();
            $(target).find("input, textarea, select").filter(":visible:enabled:first").trigger("focus");
            $("#lds-roller").hide();
        },
        error: function (request, status, error) {
            if (request.status == "500") {
                toastrerror(error);
                $("#lds-roller").hide();
            }
        },
    });
});

$(document).on("keydown", ".datetimepicker-input", function (e) {
    e.preventDefault();
});

$(document).on("keypress", ".numericonly", function (e) {
    e = e ? e : window.event;
    var charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    } else {
        return true;
    }
});

function numberFormat(number, decimals = 2, decPoint = '.', thousandsSep = ',') {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
    var s = '';

    var toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k).toFixed(prec);
    };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

$(document).on("keyup", ".js-slug", function () {
    let text = $(this).val();

    let slug = text
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

    $(this).val(slug);
});

$(document).on("input", ".price-input", function () {
    let val = $(this).val();
    val = val.replace(/[^0-9.]/g, "");
    let parts = val.split(".");
    if (parts.length > 2) {
        val = parts[0] + "." + parts[1];
    }
    if (parts[1]) {
        parts[1] = parts[1].substring(0, 2);
        val = parts[0] + "." + parts[1];
    }

    // Remove leading zeros (except "0" or "0.xx")
    val = val.replace(/^0+(\d)/, "$1");

    // Update input value
    $(this).val(val);
});

$(document).on("keypress", ".numeric-dot-only", function (e) {
    e = e ? e : window.event;
    var charCode = e.which ? e.which : e.keyCode;
    if (charCode == 46) {
        return true;
    } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    } else {
        return true;
    }
});

function ucwords(str) {
    // Split the string into words based on spaces
    var words = str.split(" ");

    // Capitalize the first letter of each word and join them back together
    for (var i = 0; i < words.length; i++) {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }

    // Join the words back into a single string
    return words.join(" ");
}

function makeEncrypt(formData) {
    const plainObject = {};
    const newFormData = new FormData();

    // Convert formData to a plain object while excluding files
    formData.forEach((value, key) => {
        if (value instanceof File) {
            newFormData.append(key, value); // Directly append files without encryption
        } else {
            const isArrayKey = key.endsWith('[]');
            const cleanKey = isArrayKey ? key.replace(/\[\]$/, '') : key; // Remove [] from key
            console.log(cleanKey);
            if (cleanKey == "_method") {
                newFormData.append(key, value);
            }
            else {
                if (plainObject[cleanKey]) {
                    // If the key already exists, append the new value
                    plainObject[cleanKey].push(value);
                } else {
                    // Initialize as an array if the key ends with [], otherwise store as a single value
                    plainObject[cleanKey] = isArrayKey ? [value] : value;
                }
            }
        }
    });

    // Encrypt the plain object
    const jsonString = JSON.stringify(plainObject);
    const key = CryptoJS.enc.Utf8.parse("WmCywsRVZrbylND2");
    const iv = CryptoJS.enc.Utf8.parse("WmCywsRVZrbylND2");
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
        iv: iv,
    }).toString();



    // Append the encrypted data to the new FormData object
    newFormData.append("data", encrypted);

    return newFormData;
}

async function ajaxDynamicMethod(url, method, formData = "", formElement = "", encryption = "Yes", isLoader = true) {
    if (isLoader) {
        $("#lds-roller").show();
    }
    const response = await $.ajax({
        type: method,
        url: url,
        data: (encryption == "Yes" && formData != "") ? makeEncrypt(formData) : ((formData != "") ? formData : ""),
        processData: false,
        contentType: false,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (data) {
            $(".errors").text("");
            $("form[action='" + url + "']").find(".has-error").removeClass("has-error");
            $("form[action='" + url + "']").find(".is-error").removeClass("is-error");
            if (data.error) {
                if (data.errors.length == "0" && data.msg) {
                    toastrerror(data.msg);
                } else {
                    for (const [key, value] of Object.entries(data.errors)) {
                        if (formElement != "") {
                            formElement.find("#" + key + "error").text(value);
                        } else {
                            var errorPoint = $("form[action='" + url + "']").find("#" + key + "error");
                            errorPoint.text(value);
                            errorPoint.closest(".inputControl").find("input").addClass("has-error");
                            errorPoint.closest(".inputControl").addClass("is-error");
                        }
                        // $("#" + key + "error").text(value);
                        // console.log("123", $("#" + key + "error").text(value));
                    }

                    if (data.sweeterror) {
                        var errorHTML = "<ul>";
                        for (const [key, value] of Object.entries(
                            data.errors
                        )) {
                            errorHTML += `<li><b>${ucwords(
                                key.replace("_", " ")
                            )} : </b>${value}</li>`;
                        }
                        errorHTML += "</ul>";

                        Swal.fire({
                            title: "Error",
                            html: errorHTML,
                            icon: "error",
                        });
                    }
                }
            } else if (data.self_reload) {
                location.reload()
            } else if (data.success && data.route) {
                console.log(data.socket_alert && socket);
                if (data.socket_alert && socket) {
                    socket.emit(data.socket_trigger, data.socket_notification);
                }
                window.location.href = data.route;
            }
        },
        error: function (request, status, error) {
            if (request.status == "500" || request.status == "405" || request.status == "400") {
                var responseMsg = (request.responseJSON && (request.responseJSON.msg || request.responseJSON.error))
                    ? (request.responseJSON.msg || request.responseJSON.error)
                    : error;
                if (typeof responseMsg !== "string") {
                    responseMsg = error;
                }
                toastrerror(responseMsg);
                $("#lds-roller").hide();
            }
        },
    });
    $("#lds-roller").hide();
    return response;
}

$(document).on("change", ".custom-file-input", function (e) {
    if ($(this).val() != "" && $(this).val() != null) {
        $(this).parent().find(".custom-file-label").text($(this).val());
        var thisRef = this;
        if ($(this).hasClass("preview-required")) {
            $(thisRef).parent().parent().find(".prview-section").remove();
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                $(thisRef)
                    .parent()
                    .parent()
                    .append(
                        '<div class="mt-3 prview-section"><img class="w-100" src="' +
                        e.target.result +
                        '"></div>'
                    );
            };
            reader.readAsDataURL(file);
        }
    } else {
        $(this)
            .parent()
            .find(".custom-file-label")
            .text(
                $(this).parent().find(".custom-file-label").data("label")
                    ? $(this).parent().find(".custom-file-label").data("label")
                    : "Choose Image"
            );
        $(this).parent().parent().find(".prview-section").remove();
    }
});

function checkMultipleDetails(form) {
    var frequencyMap = {};
    $.each(form, function (index, item) {
        var name = item.name;
        frequencyMap[name] = (frequencyMap[name] || 0) + 1;
    });

    // Extract names with frequency greater than 1
    var repeatedNames = [];
    for (var name in frequencyMap) {
        if (frequencyMap.hasOwnProperty(name) && frequencyMap[name] > 1) {
            repeatedNames.push(name);
        }
    }

    return repeatedNames;
}

function objectToFormData(obj, form, namespace) {
    let fd = form || new FormData();
    let formKey;

    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (namespace) {
                formKey = namespace + "[" + property + "]";
            } else {
                formKey = property;
            }

            // If the property is an object, but not a File, use recursion.
            if (
                typeof obj[property] === "object" &&
                !(obj[property] instanceof File)
            ) {
                objectToFormData(obj[property], fd, formKey);
            } else {
                // If it's a string or a File object, append it.
                fd.append(formKey, obj[property]);
            }
        }
    }
    return fd;
}

function generateFormData(param) {
    var dataArr = $(param).serializeArray();
    var mutipleValue = checkMultipleDetails(dataArr);
    var formData = new FormData();
    $.each(dataArr, function (i, field) {
        if ($.inArray(field.name, mutipleValue) !== -1) {
        } else {
            formData.append(field.name, field.value);
        }
    });
    $.each(mutipleValue, function (index, value) {
        $.each(dataArr, function (i, field) {
            if (field.name == value) {
                formData.append(
                    field.name.replace("[]", "") + "[]",
                    field.value
                );
            }
        });
    });
    $.each(
        $(param).find('input[type="file"]:not([multiple])'),
        function (i, field) {
            formData.append(
                field.name,
                $(field)[0].files[0] != undefined ? $(field)[0].files[0] : ""
            );
        }
    );
    $.each($(param).find('input[type="file"][multiple]'), function (i, field) {
        var fileInput = $(field)[0];
        var files = fileInput.files;
        for (var i = 0; i < files.length; i++) {
            formData.append(field.name.replace("[]", "") + "[]", files[i]);
        }
        // formData.append(field.name + "[]", (($(field)[0].files[0]) != undefined) ? $(field)[0].files[0] : "");
    });

    return formData;
}

$(document).on("click", ".sidebar-link", async function () {
    var url = $(this).data("url");
    if ($("#kt_side_panel").hasClass("offcanvas-on")) {
        closeSettingSidebar();
    } else {
        var response = await ajaxDynamicMethod(url, "GET");
        $("#kt_side_panel .tab-content").html(response.data.html);
        $("#kt_side_panel").addClass("offcanvas-on");
    }
});

function closeSettingSidebar(alert = true) {
    if (alert) {
        Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, proceed!",
        }).then((result) => {
            if (result.isConfirmed) {
                $("#kt_side_panel").removeClass("offcanvas-on");
            }
        });
    } else {
        $("#kt_side_panel").removeClass("offcanvas-on");
    }
}

$(document).on("click", "#kt_side_panel_close", function (e) {
    e.preventDefault();
    closeSettingSidebar();
});

window.onpageshow = function (event) {
    if (event.persisted) {
        location.reload();
    }
};

document.addEventListener("DOMContentLoaded", function () {
    let lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const lazyLoad = (target) => {
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.removeAttribute("data-src");
                    observer.disconnect();
                }
            });
        });

        io.observe(target);
    };

    lazyImages.forEach(lazyLoad);
});


$(document).on("blur", ".qty-input:not(.qty-update)", async function () {
    if ($(this).val() == "" || $(this).val() == null || $(this).val() == undefined || $(this).val() == "0" || parseInt($(this).val()) < 0) {
        $(this).val("1");
    }
});

$(document).on("blur", ".qty-update", async function () {
    if ($(this).val() == "" || $(this).val() == null || $(this).val() == undefined || $(this).val() == "0" || parseInt($(this).val()) < 0) {
        $(this).val($(this).data('old'));
    }

    if ($(this).data("href")) {
        var data = await ajaxDynamicMethod($(this).data('href') + "?qty=" + $(this).val(), "GET", "", "", "Yes", false);
        if (data.success) {
            $(".cartTotalamount").text(data.data.cart_total);
            $(".cartItem" + data.data.id).find(".qty-input").val(data.data.quantity);
            $(".cartItem" + data.data.id).find(".qty-input").data('old', data.data.quantity).attr('data-old', data.data.quantity);
            $(".cartItem" + data.data.id).find(".cartItemPrice span").text(data.data.price);
            $(".cartItem" + data.data.id).find(".cartItemQuantity").text(data.data.quantity);
            $(".navbar__cartHeader .cartCount").text(data.data.header_count);
            $(".navbar__icon--cart .cartCount").text(data.data.header_count);
            $(".cartHeader .cartSubtitle").text(`You have total ${data.data.header_count} Items in your cart`);
            if (typeof updateCheckoutPrice === "function") {
                updateCheckoutPrice();
            }
        }
    }
});

$(document).on("click", ".cartItem .deleteBtn", async function () {
    UIAlerts.confirm({
        title: 'Are you sure?',
        text: "You want to remove this product!",
    }).then(async (result) => {
        if (result.isConfirmed) {
            var data = await ajaxDynamicMethod($(this).data('href'), "GET");
            if (data.success) {
                $(".cartItem" + data.data.id).remove();
                $(".navbar__icon--cart").find(".cartCount").remove();
                $(".navbar__icon--cart").prepend(`<span class="cartCount">${data.data.header_count}</span>`);
                $(".cartSubtitle").text(`You have total ${data.data.header_count} Items in your cart`);
                $(".navbar__cartHeader .cartCount").text(data.data.header_count);
                $(".cartTotalamount").text(data.data.cart_total);
                if (typeof checkCheckOutItems === "function") {
                    checkCheckOutItems();
                }
                if (typeof updateCheckoutPrice === "function") {
                    updateCheckoutPrice();
                }
            }
        }
    })
});

$(document).on("click", ".qty-control .minus", async function () {
    let $input = $(this).closest(".qty-control").find(".qty-input");
    let val = parseInt($input.val(), 10) || 1;
    let min = parseInt($input.attr("min") || 1, 10);

    if (val > min) {
        $input.val(val - 1);
    }

    if ($input.val() == "" || $input.val() == null || $input.val() == undefined || $input.val() == "0" || parseInt($input.val()) < 0) {
        $input.val("1");
    }

    if ($(this).data("href")) {
        var data = await ajaxDynamicMethod($(this).data('href'), "GET");
        if (data.success) {
            $(".cartTotalamount").text(data.data.cart_total);
            $(".cartItem" + data.data.id).find(".qty-input").val(data.data.quantity);
            $(".cartItem" + data.data.id).find(".qty-input").data('old', data.data.quantity).attr('data-old', data.data.quantity);
            $(".cartItem" + data.data.id).find(".cartItemPrice span").text(data.data.price);
            $(".cartItem" + data.data.id).find(".cartItemQuantity").text(data.data.quantity);
            $(".navbar__cartHeader .cartCount").text(data.data.header_count);
            $(".navbar__icon--cart .cartCount").text(data.data.header_count);
            $(".cartHeader .cartSubtitle").text(`You have total ${data.data.header_count} Items in your cart`);
            if (typeof updateCheckoutPrice === "function") {
                updateCheckoutPrice();
            }
        }
    }
});

$(document).on("click", ".qty-control .plus", async function () {
    let $input = $(this).closest(".qty-control").find(".qty-input");
    if ($input.prop("disabled")) {
        return;
    }
    let val = parseInt($input.val(), 10) || 1;
    let max = parseInt($input.attr("max"), 10);
    if (!isNaN(max) && val >= max) {
        $input.val(max);
        if (typeof toastrerror === "function") {
            toastrerror("Only " + max + " item(s) available in stock.");
        }
        return;
    }
    $input.val(val + 1);
    if ($(this).data("href")) {
        var data = await ajaxDynamicMethod($(this).data('href'), "GET");
        if (data.success) {
            $(".cartTotalamount").text(data.data.cart_total);
            $(".cartItem" + data.data.id).find(".qty-input").val(data.data.quantity);
            $(".cartItem" + data.data.id).find(".qty-input").data('old', data.data.quantity).attr('data-old', data.data.quantity);
            $(".cartItem" + data.data.id).find(".cartItemPrice span").text(data.data.price);
            $(".cartItem" + data.data.id).find(".cartItemQuantity").text(data.data.quantity);
            $(".navbar__cartHeader .cartCount").text(data.data.header_count);
            $(".navbar__icon--cart .cartCount").text(data.data.header_count);
            $(".cartHeader .cartSubtitle").text(`You have total ${data.data.header_count} Items in your cart`);
            if (typeof updateCheckoutPrice === "function") {
                updateCheckoutPrice();
            }
        } else if (data.msg && typeof toastrerror === "function") {
            $input.val(val);
            toastrerror(data.msg);
        }
    }
});


$(document).on("change", ".collectionContainer .finishToggle .finishToggle__input", function () {
    var finishSlug = $(this).val();
    var finishId = $(this).data("id");
    $(".collectionList .finish_id").val(finishId);
    var $images = $(this).closest(".collectionContainer").find('.product-img');
    var $finishImage = $(this).closest(".collectionContainer").find('.product-img[data-finish="' + finishSlug + '"]');
    var $defaultImage = $(this).closest(".collectionContainer").find('.default-image');

    var $price = $(this).closest(".collectionContainer").find('.product-price');
    var $finishPrice = $(this).closest(".collectionContainer").find('.product-price[data-finish="' + finishSlug + '"]');
    var $defaultPrice = $(this).closest(".collectionContainer").find('.default-price');

    $images.removeClass('active').hide();
    $price.removeClass('active').hide();
    $defaultImage.hide();
    $defaultPrice.hide();
    if ($finishImage.length) {
        $finishImage.addClass('active').fadeIn(150);
        $finishPrice.addClass('active').fadeIn(150);
    } else {
        $defaultImage.addClass('active').fadeIn(150);
        $defaultPrice.addClass('active').fadeIn(150);
    }
});

$(document).on("click", ".addNewCollection", function (e) {
    e.preventDefault();
    $(".newCollectionSection").show();
    $(".addNewCollection").hide();
});

$(document).on("submit", "#makeNewCollection", async function (e) {
    e.preventDefault();
    $("#makeNewCollection").find(".finish_id").val($(".collectionContainer input[name=productViewFinish]:checked").data("id"));
    var data = await ajaxDynamicMethod($(this).attr('action'), $(this).attr('method'), generateFormData(
        this));
    if (data.success) {
        toastrsuccess(data.msg);
        closeCommonModel();
    }
});
$(document).on("submit", ".addToCollectionForm", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod($(this).attr('action'), $(this).attr('method'), generateFormData(
        this));
    if (data.success) {
        toastrsuccess(data.msg);
        closeCommonModel();
    }
});


async function getGlobalSearch(value) {
    var formData = new FormData();
    formData.append("search_text", value);
    var data = await ajaxDynamicMethod($('input[name=global_search]').data("route"), "POST", formData);
    if (data.success) {
        $("#global__search").html(data.data.html);
    }
}

function globalDebounce(fn, delay) {
    let timer = null;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
    };
}

const globalDebouncedSearch = globalDebounce(function () {
    const query = $('input[name=global_search]').val().trim();
    getGlobalSearch(query);
}, 600);
$(document).on('input', 'input[name=global_search]', globalDebouncedSearch);
